import { init, send } from 'emailjs-com'
import { toast } from 'react-hot-toast'

const userId = process.env.REACT_APP_EMAIL_JS_USER_ID
const serviceId = process.env.REACT_APP_EMAIL_JS_SERVICE_ID

// const accessToken = '2ad5cb19f8047197ce4a7d52844b2aad'
const templateId = 'template_e99m8vq'
init(userId)

/**
 * Wysyła jedną wiadomość przez EmailJS. Zwraca Promise — kolejne wywołania
 * należy odpalać sekwencyjnie (await), żeby uniknąć błędu concurrent requests.
 * @param {{ suppressToast?: boolean }} opts — przy masowej wysyłce wycisz toasty (podsumowanie po stronie wywołującego)
 */
export const sendEmail = ({ students, message, title, suppressToast = false }) => {
  const templateParams = {
    title,
    message,
    from_name: 'Smart School',
    to_email: students.join(','),
    reply_to: 'smartschoolpl@gmail.com',
  }

  return send(serviceId, templateId, templateParams)
    .then(response => {
      if (!suppressToast) {
        toast.success('Wiadomość została wysłana')
      }
      return response
    })
    .catch(err => {
      if (!suppressToast) {
        toast.error('Nie udało się wysłać wiadomości')
      }
      return Promise.reject(err)
    })
}
